import { filterMarker, fitAllMarkers } from "./filter-markers";

function infoWindow(map, target) {
  $(`.${target}`).addClass("active").siblings().removeClass("active");
  $(".store__aside").addClass("info-active").scrollTop(0);

  const marker = mapMarkers.filter(marker => {
    return marker.target == target;
  });
  map.setCenter(marker[0].location);
  map.setZoom(16);

  $("html, body").animate({
    scrollTop: 0
  });
}

function closeInfoWindow(map) {
  $(".stores .store-info .close").on("click", function() {
    $(".store-info.active").removeClass("active");
    $(".store__aside").removeClass("info-active");
    const $results = $(".store-results");
    if ($results.is(":visible")) {
      const markers = [];
      $results.find("a[data-target]").each(function() {
        const $this = $(this);
        const thisTarget = $this.data("target");
        const marker = mapMarkers.filter(item => {
          return item.target == thisTarget;
        });
        markers.push(marker[0]);
      });
      fitAllMarkers(map, markers);
    } else {
      const thisText = $(".store-locations .active:eq(-1) li:eq(0) > h2").text().toLowerCase();
      const filteredMarkers = filterMarker(thisText);
      fitAllMarkers(map, filteredMarkers);
    }
  });
}

module.exports = {
  infoWindow,
  closeInfoWindow
};



// WEBPACK FOOTER //
// ../assets/js/map/info-window.js